(function () {
  if (window.__testimonialSliderReady) return;
  window.__testimonialSliderReady = true;

  function init(root) {
    if (!root || root.dataset.testimonialSliderInitialized === 'true') return;

    var viewport = root.querySelector('[data-ts-viewport]');
    var track = root.querySelector('[data-ts-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ts-slide]'));
    var prevBtn = root.querySelector('[data-ts-prev]');
    var nextBtn = root.querySelector('[data-ts-next]');

    if (!viewport || !track || !slides.length) return;
    root.dataset.testimonialSliderInitialized = 'true';

    var beforeClones = document.createDocumentFragment();
    var afterClones = document.createDocumentFragment();

    slides.forEach(function (slide) {
      var beforeClone = slide.cloneNode(true);
      var afterClone = slide.cloneNode(true);

      beforeClone.setAttribute('aria-hidden', 'true');
      afterClone.setAttribute('aria-hidden', 'true');
      beforeClone.removeAttribute('id');
      afterClone.removeAttribute('id');

      beforeClones.appendChild(beforeClone);
      afterClones.appendChild(afterClone);
    });

    track.insertBefore(beforeClones, track.firstChild);
    track.appendChild(afterClones);

    var state = {
      current: 0,
      perView: 3,
      step: 0,
      slideCount: slides.length
    };

    function getPerView() {
      if (window.matchMedia('(max-width: 749px)').matches) return 1;
      if (window.matchMedia('(max-width: 989px)').matches) return 2;
      return 3;
    }

    function getGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0) || 0;
    }

    function measure() {
      state.perView = getPerView();
      state.step = slides[0] ? slides[0].getBoundingClientRect().width + getGap() : 0;
    }

    function getTrackIndex() {
      return state.current + state.slideCount;
    }

    function render(animate) {
      var x = getTrackIndex() * state.step;
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';

      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    function goTo(index) {
      state.current = index;
      render(true);
    }

    function next() {
      goTo(state.current + 1);
    }

    function prev() {
      goTo(state.current - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    track.addEventListener('transitionend', function () {
      if (state.current < 0) {
        state.current = state.slideCount - 1;
        render(false);
      } else if (state.current >= state.slideCount) {
        state.current = 0;
        render(false);
      }
    });

    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var deltaY = 0;
    var touching = false;

    viewport.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      touching = true;
      startX = touch.clientX;
      startY = touch.clientY;
      deltaX = 0;
      deltaY = 0;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (event) {
      if (!touching) return;
      var touch = event.touches[0];
      deltaX = touch.clientX - startX;
      deltaY = touch.clientY - startY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && event.cancelable) {
        event.preventDefault();
      }
    }, { passive: false });

    viewport.addEventListener('touchend', function () {
      if (!touching) return;
      touching = false;

      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) next();
        else prev();
      }
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measure();
        render(false);
      }, 100);
    });

    measure();
    render(false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ts-root]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
